import { ApiResponse, UserDocument, UserDocumentId, UserDocumentUploadRequest, UserId } from '@arrived/models';

import { api } from './api';
import { buildMultipartFormData, getBlob, unwrapApiResponse } from './utils';

// TODO: buildMultipartFormData hasn't been tested
export const postUploadUserDocument = async (request: UserDocumentUploadRequest) => {
  const { body, headers } = buildMultipartFormData(request);
  const response = await api.post<ApiResponse<UserDocument>>(`/users/${request.userId}/documents`, body, { headers });

  return unwrapApiResponse(response.data);
};

export const getUserDocuments = async (userId: UserId) => {
  const response = await api.get<ApiResponse<UserDocument[]>>(`/users/${userId}/documents`);

  return unwrapApiResponse(response.data);
};

export const getUserDocument = async (documentId: UserDocumentId) => {
  const response = await api.get<ApiResponse<UserDocument>>(`/users/documents/${documentId}`);

  return unwrapApiResponse(response.data);
};

export const getUserDocumentRaw = async (documentId: UserDocumentId) => {
  return await getBlob(`/users/documents/${documentId}/raw`);
};

export const deleteUserDocument = async (documentId: UserDocumentId) => {
  const response = await api.delete<ApiResponse<UserDocument>>(`/users/documents/${documentId}`);

  return unwrapApiResponse(response.data);
};
